import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	search: {
		id: 'software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.search',
		defaultMessage: 'Search',
		description: 'Label for the search input placeholder in context menu',
	},
	loading: {
		id: 'software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.loading',
		defaultMessage: 'Loading...',
		description: 'Message to let users know that there is a search happening',
	},
	noResults: {
		id: 'software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.no-results',
		defaultMessage: 'No results',
		description: 'Message to tell users that there are no results for the search',
	},
});
